import React, { useContext, useState, useEffect, useCallback } from 'react'
import styled from 'styled-components'

import withNotifications from '~/components/with-notifications'
import { MIN_DESKTOP_THRESHOLD, LANDING_PAGE_WIDTH, MAX_MOBILE_THRESHOLD } from '~/core/constants'

import { ColumnFlexCentered } from '~/components/common/containers'
import Addons from './addons'
import Footer from './footer'
import FreePlan from './free-plan'
import Logo from './logo'
import ViewUpgradeOptions from './view-upgrade-options'
import AllPlansPage from './all-plans-page'
import { Context } from '../context'
import CancelButton from '../cancel-button'
import StyledSpinner from '../common/spinner'

const UPGRADE_HASH = '#upgradeOptions'

const Container = styled(ColumnFlexCentered)`
  margin: 32px auto 65px;

  ${Addons} {
    background-color: transparent;
    border: 1px solid #C4C4C4;
    border-radius: 8px;
  }

  @media screen and (min-width: ${MIN_DESKTOP_THRESHOLD}) {
    width: ${LANDING_PAGE_WIDTH};
  }

  @media screen and (min-width: ${MAX_MOBILE_THRESHOLD}) {
    ${Addons} {
      width: 640px;
    }
  }
`

const App = () => {
  const { getSession, products, loading } = useContext(Context)

  const [showUpgradePage, setShowUpgradePage] = useState(false)

  const viewUpgrade = useCallback(() => {
    setShowUpgradePage(true)
    window.location.hash = UPGRADE_HASH
  }, [setShowUpgradePage])

  const onHashChanged = useCallback(() => {
    if (window.location.hash === UPGRADE_HASH) {
      setShowUpgradePage(true)
    } else {
      setShowUpgradePage(false)
    }
  }, [setShowUpgradePage])

  useEffect(() => {
    window.addEventListener('hashchange', onHashChanged)
    return () => {
      window.removeEventListener('hashchange', onHashChanged)
    }
  }, [onHashChanged])

  if (loading) {
    return <StyledSpinner />
  }

  if (showUpgradePage) {
    return (
      <AllPlansPage
        products={products}
        selectPlan={getSession}
        showAddCoupon
        showCancel
      />
    )
  }

  return (
    <Container>
      <Logo />
      <FreePlan />
      <Addons products={products} noCreditCard />
      <ViewUpgradeOptions onViewUpgrade={viewUpgrade} />
      <CancelButton />
      <Footer />
    </Container>
  )
}

export default withNotifications(App)
